import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlidadeConfigModel } from '../../../core/services/models/alidade-config.model';
import { ApiResponseCreateSuccessModel, ApiResponseModel } from '../../../shared/models/api-response.model';
import { SkipLogicItems } from '../store/measure.state';
import {
  SkipLogicSubExpressionsItemModel,
  SkipLogicSubExpressionsItemPostModel,
} from '../models/api/builder-skip-logic-item.model';

@Injectable({
  providedIn: 'root',
})
export class SkipLogicService {
  private readonly apiUrl: string;

  constructor(
    @Inject('ALIDADE_CONFIG') config: AlidadeConfigModel,
    private http: HttpClient,
  ) {
    this.apiUrl = `${config.apiURL}/builder`;
  }

  createSkipLogicItem(
    skipLogicItemsOid: number,
    data: SkipLogicItems,
  ): Observable<ApiResponseModel<ApiResponseCreateSuccessModel[]>> {
    return this.http.post<ApiResponseModel<ApiResponseCreateSuccessModel[]>>(
      `${this.apiUrl}/questions/${skipLogicItemsOid}/skipLogicItems`,
      {
        ...data,
      },
    );
  }

  updateSkipLogicItem(skipLogicItemsOid: number, data: SkipLogicItems): Observable<ApiResponseModel<void>> {
    return this.http.put<ApiResponseModel<void>>(`${this.apiUrl}/skipLogicItems/${skipLogicItemsOid}`, {
      ...data,
    });
  }

  createSkipLogicExpressions(
    skipLogicItemOid: number,
    data: any,
  ): Observable<ApiResponseModel<ApiResponseCreateSuccessModel[]>> {
    return this.http.post<ApiResponseModel<ApiResponseCreateSuccessModel[]>>(
      `${this.apiUrl}/skipLogicItems/${skipLogicItemOid}/expressions`,
      {
        ...data,
      },
    );
  }

  updateSkipLogicExpressions(skipLogicItemOid: number, data: any): Observable<ApiResponseModel<void>> {
    return this.http.put<ApiResponseModel<void>>(`${this.apiUrl}/expressions/${skipLogicItemOid}`, {
      ...data,
    });
  }

  createSubExpression(
    expressionsOid: number,
    data: SkipLogicSubExpressionsItemPostModel,
  ): Observable<ApiResponseModel<SkipLogicSubExpressionsItemModel>> {
    return this.http.post<ApiResponseModel<SkipLogicSubExpressionsItemModel>>(
      `${this.apiUrl}/expressions/${expressionsOid}/subExpressions`,
      data,
    );
  }

  updateSubExpression(
    subExpressionsOid: number,
    data: SkipLogicSubExpressionsItemPostModel,
  ): Observable<ApiResponseModel<ApiResponseModel<void>>> {
    return this.http.put<ApiResponseModel<ApiResponseModel<void>>>(
      `${this.apiUrl}/subExpressions/${subExpressionsOid}`,
      data,
    );
  }

  removeSkipLogicItem(skipLogicItemOid: number): Observable<ApiResponseModel<void>> {
    return this.http.delete<ApiResponseModel<void>>(`${this.apiUrl}/skipLogicItems/${skipLogicItemOid}`);
  }
}
